<ng-template #feedback>
 <div class="notice error feedback-card" *ngIf="error() && !selected()" role="alert">
  <wiz-icon name="help"></wiz-icon><span class="feedback-message">{{ error() }}</span>
  <button type="button" class="icon-button" aria-label="파일 작업 오류 닫기" (click)="error.set('')"><wiz-icon name="close"></wiz-icon></button>
 </div>
 <div class="notice feedback-card" *ngIf="message() && !selected()" role="status" aria-atomic="true" [class.success]="!busy()">
  <span class="spinner" *ngIf="busy()" aria-hidden="true"></span>
  <span class="feedback-message">{{ message() }}</span>
  <button type="button" class="icon-button" *ngIf="!busy()" aria-label="파일 작업 알림 닫기" (click)="message.set('')"><wiz-icon name="close"></wiz-icon></button>
 </div>
</ng-template>
<section class="panel file-browser">
  <div class="panel-header">
    <h2>
      <wiz-icon name="file"></wiz-icon>{{ serviceId ? '서비스 · 컨테이너 파일' :
      '서버 파일' }}
    </h2>
    <div class="toolbar-right">
      <label class="hidden-switch"
        ><input
          type="checkbox"
          role="switch"
          [(ngModel)]="hidden"
          (ngModelChange)="load()"
          [disabled]="busy() || loading()"
        /><span class="switch-track" aria-hidden="true"></span><span>숨김 파일</span></label
      ><button
        class="icon-button"
        type="button"
        (click)="load()"
        [disabled]="busy() || loading()"
        aria-label="파일 목록 새로고침"
        title="파일 목록 새로고침"
      >
        <wiz-icon name="refresh"></wiz-icon>
      </button>
    </div>
  </div>
  <div class="allowed-roots" *ngIf="serverId">
    <strong>로컬 경로 허용 목록</strong><span class="badge neutral">읽기 전용</span>
    <p>홈 디렉터리와 아래 고정된 추가 경로에서 파일을 탐색할 수 있습니다.</p>
    <ng-container *ngIf="approvedRoots() as roots; else rootsPending">
      <code *ngFor="let root of roots">{{ root }}</code>
      <span *ngIf="!roots.length">추가 허용 경로 없음</span>
    </ng-container>
    <ng-template #rootsPending><span [attr.role]="rootsError() ? 'alert' : 'status'">{{ rootsError() || '허용 경로를 읽는 중입니다.' }}</span></ng-template>
  </div>
  <div class="allowed-roots" *ngIf="serviceId && !component"><strong>서버의 Compose 디렉터리</strong><code>{{ listing()['rootPath'] || '배포 경로 확인 중…' }}</code><p>이 디렉터리와 하위 폴더에서만 탐색할 수 있습니다.</p><p *ngIf="listing()['pending']">배포 전에는 서버에 Compose 파일이 없습니다. Compose 탭에서 구성을 확인하세요.</p></div>
  <form class="toolbar path-toolbar" (ngSubmit)="load(path)">
    <select
      *ngIf="serviceId"
      name="fileTarget"
      class="filter-select"
      aria-label="파일 탐색 대상"
      [(ngModel)]="component"
      (ngModelChange)="changeTarget()"
      [disabled]="busy() || dirty()"
    >
      <option value="">서비스 파일</option>
      <option *ngFor="let row of containers" [value]="name(row)">
        컨테이너 · {{ name(row) }}
      </option></select
    ><button
      class="button small"
      type="button"
      (click)="load(listing()['parent'])"
      [disabled]="!listing()['parent'] || busy() || loading()"
    >
      <wiz-icon name="upload"></wiz-icon>상위 폴더</button
    ><input
      class="filter-select path-input"
      name="browsePath"
      [(ngModel)]="path"
      aria-label="탐색할 경로"
      [placeholder]="serviceId && !component ? '서비스 Compose 디렉터리' : '홈 또는 승인된 파일 경로'"
    /><button
      type="submit"
      class="button small"
      [disabled]="busy() || loading()"
    >
      <wiz-icon name="arrow"></wiz-icon>폴더 열기
    </button>
  </form>
  <div class="toolbar file-actions">
    <div class="toolbar-left">
      <input
        #fileInput
        hidden
        type="file"
        multiple
        (change)="upload($event)"
      /><button
        type="button"
        class="button primary small"
        (click)="fileInput.click()"
        [disabled]="busy() || loading() || !listing()['path'] || dirty()"
      >
        <wiz-icon name="upload"></wiz-icon>파일 업로드</button
      ><button
        type="button"
        class="button small"
        (click)="createKind='directory';createName=''"
        [disabled]="busy() || loading() || !listing()['path'] || dirty()"
      >
        <wiz-icon name="plus"></wiz-icon>새 폴더</button
      ><button
        type="button"
        class="button small"
        (click)="createKind='file';createName=''"
        [disabled]="busy() || loading() || !listing()['path'] || dirty()"
      >
        <wiz-icon name="file"></wiz-icon>새 파일
      </button>
    </div>
    <span class="small-note"
      >지원하는 UTF-8 텍스트 파일을 편집할 수 있습니다.</span
    >
  </div>
  <form class="create-row" *ngIf="createKind" (ngSubmit)="create()">
    <label class="field"
      >{{ createKind==='directory' ? '새 폴더 이름' : '새 파일 이름' }}<input
        name="newFileName"
        [(ngModel)]="createName"
        maxlength="255"
        required /></label
    ><button
      class="button primary small"
      type="submit"
      [disabled]="busy() || !createName.trim()"
    >
      <wiz-icon name="plus"></wiz-icon>만들기</button
    ><button
      class="button small"
      type="button"
      (click)="createKind=''"
      [disabled]="busy()"
    >
      <wiz-icon name="close"></wiz-icon>취소
    </button>
  </form>
  <div class="table-wrap">
    <table *ngIf="listing()['entries']?.length">
      <thead>
        <tr>
          <th>이름</th>
          <th>크기</th>
          <th>작업</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let file of listing()['entries']">
          <td>
            <button
              type="button"
              class="text-link file-name"
              *ngIf="file.directory || editable(file); else plainFileName"
              [disabled]="busy()"
              (click)="file.directory ? load(file.path) : open(file)"
            >
              <wiz-icon [name]="file.directory ? 'layers' : 'file'"></wiz-icon
              >{{ file.name }}{{ file.directory ? '/' : '' }}
            </button>
            <ng-template #plainFileName><span class="file-name plain-file-name"><wiz-icon name="file"></wiz-icon>{{ file.name }}</span></ng-template>
          </td>
          <td>{{ file.directory ? '폴더' : bytes(file.size) }}</td>
          <td>
            <div class="row-actions">
              <button
                type="button"
                class="button small"
                *ngIf="serverId && !file.directory && compose(file)"
                (click)="composeSelected.emit(file)"
                [disabled]="busy()"
              >
                <wiz-icon name="cube"></wiz-icon>서비스로 가져오기</button
              ><button
                class="icon-button"
                *ngIf="editable(file)"
                type="button"
                (click)="open(file)"
                [disabled]="busy()"
                aria-label="파일 편집"
                title="파일 편집"
              >
                <wiz-icon name="edit"></wiz-icon></button
              ><button
                class="icon-button"
                *ngIf="!file.directory"
                type="button"
                (click)="download(file)"
                [disabled]="busy()"
                aria-label="파일 다운로드"
                title="파일 다운로드"
              >
                <wiz-icon name="download"></wiz-icon></button
              ><button
                class="icon-button danger"
                type="button"
                (click)="requestDelete(file)"
                [disabled]="busy()"
                [attr.aria-label]="serverId ? '파일 또는 폴더 삭제' : '파일 또는 빈 폴더 삭제'"
                [attr.title]="serverId ? '파일 또는 폴더 삭제' : '파일 또는 빈 폴더 삭제'"
              >
                <wiz-icon name="trash"></wiz-icon>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="empty-state" *ngIf="!listing()['entries']?.length">
    <wiz-icon name="file"></wiz-icon>
    <h3>
      {{ loading() ? '파일 목록을 읽는 중입니다' : error() ? '파일 목록을 확인할
      수 없습니다' : '폴더가 비어 있습니다' }}
    </h3>
    <p *ngIf="!loading() && !error()">
      파일을 업로드하거나 새 파일·폴더를 만드세요.
    </p>
  </div>
  <div class="modal-backdrop" *ngIf="pendingDelete() as file">
    <section #deleteDialog class="modal delete-modal" tabindex="-1" (keydown)="deleteKeys($event)" role="dialog" aria-modal="true" aria-labelledby="file-delete-title" [attr.aria-busy]="busy() || deleteLoading()" (click)="$event.stopPropagation()">
      <header class="modal-header">
        <div><h2 id="file-delete-title">{{ file['name'] }} 삭제</h2>
          <p>{{ file['directory'] ? (serverId ? '폴더와 내부의 모든 파일·하위 폴더를 영구 삭제합니다.' : '비어 있는 폴더만 삭제할 수 있습니다.') : '삭제한 파일은 복원할 수 없습니다.' }}</p>
        </div>
        <button class="icon-button" type="button" (click)="closeDelete()" [disabled]="busy()" aria-label="삭제 확인 닫기"><wiz-icon name="close"></wiz-icon></button>
      </header>
      <div class="modal-content delete-details">
        <div class="delete-path"><strong>삭제 경로</strong><code>{{ file['path'] }}</code></div>
        <p *ngIf="!file['directory']">파일 용량: {{ bytes(file['size']) }}</p>
        <ng-container *ngIf="serverId && file['directory']">
          <p *ngIf="deleteLoading()" role="status">숨김 파일을 포함한 폴더 용량과 내용을 확인하고 있습니다.</p>
          <ng-container *ngIf="deleteReview() as review">
            <dl class="delete-summary">
              <div><dt>파일 용량 합계</dt><dd>{{ bytes(review['bytes']) }}</dd></div>
              <div><dt>파일</dt><dd>{{ review['files'] }}개</dd></div>
              <div><dt>하위 폴더</dt><dd>{{ review['directories'] }}개</dd></div>
              <div><dt>심볼릭 링크</dt><dd>{{ review['links'] }}개</dd></div>
            </dl>
            <p class="small-note">숨김 파일도 모두 포함합니다. 심볼릭 링크는 링크만 삭제하며 연결된 대상은 삭제하지 않습니다.</p>
            <div class="delete-contents" *ngIf="review['entries']?.length; else emptyFolder">
              <h3>폴더 내용</h3>
              <p class="small-note" *ngIf="review['truncated']">전체 {{ review['files'] + review['directories'] + review['links'] }}개 중 {{ review['entries'].length }}개를 표시합니다. 용량과 개수는 전체 기준입니다.</p>
              <ul><li *ngFor="let entry of review['entries']"><code>{{ entry.path }}</code><span>{{ entry.kind==='directory' ? '폴더' : entry.kind==='link' ? '심볼릭 링크' : bytes(entry.bytes) }}</span></li></ul>
            </div>
            <ng-template #emptyFolder><p>비어 있는 폴더입니다.</p></ng-template>
            <div class="notice warn">삭제 후 복구할 수 없습니다. 실행 중인 서비스가 사용하는 폴더라면 서비스에 영향을 줄 수 있습니다.</div>
            <label class="field">확인을 위해 폴더명 <strong>{{ file['name'] }}</strong>을(를) 입력하세요.
              <input name="deleteFolderName" [(ngModel)]="deleteName" autocomplete="off" [disabled]="busy()" aria-label="삭제할 폴더명 확인" />
            </label>
            <label class="checkbox-label"><input type="checkbox" [(ngModel)]="deleteConfirmed" [disabled]="busy()" />폴더와 내부 항목이 영구 삭제됨을 확인했습니다.</label>
          </ng-container>
        </ng-container>
        <div class="notice error" *ngIf="deleteError()" role="alert">{{ deleteError() }}</div>
        <button class="button small" type="button" *ngIf="serverId && file['directory'] && !deleteLoading() && !deleteReview()" (click)="reviewDelete()" [disabled]="busy()"><wiz-icon name="refresh"></wiz-icon>상세 정보 다시 조회</button>
      </div>
      <footer class="modal-footer">
        <button class="button" type="button" (click)="closeDelete()" [disabled]="busy()"><wiz-icon name="close"></wiz-icon>취소</button>
        <button class="button danger" type="button" (click)="remove()" [disabled]="!canDelete()"><wiz-icon name="trash"></wiz-icon>{{ busy() ? '삭제 중…' : file['directory'] ? '폴더 삭제' : '파일 삭제' }}</button>
      </footer>
    </section>
  </div>
  <div
    class="modal-backdrop"
    *ngIf="selected() as file"
  >
    <section
      class="modal wide file-editor-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="file-editor-title"
      (click)="$event.stopPropagation()"
    >
      <header class="modal-header">
        <div>
          <h2 id="file-editor-title">{{ file['path'] }}</h2>
          <p>
            {{ dirty() ? '저장하지 않은 변경이 있습니다.' : '파일 내용을
            편집합니다.' }}
          </p>
        </div>
        <button
          type="button"
          class="icon-button"
          (click)="closeEditor()"
          [disabled]="busy()"
          aria-label="파일 편집 닫기"
        >
          <wiz-icon name="close"></wiz-icon>
        </button>
      </header>
      <div class="modal-content">
        <div class="notice error" *ngIf="error()" role="alert">{{ error() }}</div>
        <div class="notice success" *ngIf="message()" role="status">{{ message() }}</div>
        <div class="notice warn" *ngIf="discardPending()">
          <span>저장하지 않은 변경을 버리고 닫을까요?</span
          ><button
            class="button danger small"
            type="button"
            (click)="closeEditor(true)"
          >
            <wiz-icon name="trash"></wiz-icon>변경 버리기</button
          ><button
            class="button small"
            type="button"
            (click)="discardPending.set(false)"
          >
            <wiz-icon name="edit"></wiz-icon>계속 편집
          </button>
        </div>
        <wiz-code-editor
          [(ngModel)]="content"
          [language]="language()"
          [rows]="24"
          label="파일 내용"
        ></wiz-code-editor>
      </div>
      <footer class="modal-footer">
        <button
          type="button"
          class="button"
          (click)="closeEditor()"
          [disabled]="busy()"
        >
          <wiz-icon name="close"></wiz-icon>닫기</button
        ><button
          type="button"
          class="button primary"
          (click)="save()"
          [disabled]="busy() || !dirty()"
        >
          <wiz-icon name="save"></wiz-icon>파일 저장
        </button>
      </footer>
    </section>
  </div>
</section>
